<template>
    <l-map
        class="widget-static-map"
        :center="center"
        :zoom="zoom"
        :options="mapOptions"
		@ready="onMapReady"
    >
        <l-tile-layer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <l-marker
            :lat-lng="center"
            :icon="markerIcon"
        />
    </l-map>
</template>

<script>
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import L from 'leaflet';

export default {
    name: 'WidgetStaticMap',
    components: {
        LMap,
        LTileLayer,
        LMarker,
    },
    props: {
        lat: {
            type: Number,
            required: true,
        },
        lng: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            zoom: 13,
            mapOptions: {
                zoomControl: false,
                dragging: false,
                touchZoom: false,
                doubleClickZoom: false,
                scrollWheelZoom: false,
                boxZoom: false,
                keyboard: false,
                attributionControl: false,
            },
            markerIcon: L.divIcon({
                className: '',
                html: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="36" viewBox="0 0 24 36"><path d="M12 0C5.373 0 0 5.373 0 12c0 9 12 24 12 24S24 21 24 12C24 5.373 18.627 0 12 0z" fill="#ff3d00"/><circle cx="12" cy="12" r="5" fill="#fff"/></svg>',
                iconSize: [24, 36],
                iconAnchor: [12, 36],
            }),
        };
    },
    computed: {
        center() {
            return [this.lat, this.lng];
        },
    },
    methods: {
        onMapReady(map) {
            this._map = map;
        },
        refresh() {
            this.$nextTick(() => {
                if (this._map) {
                    this._map.invalidateSize();
                }
            });
        },
    },
};
</script>

<style scoped>
.widget-static-map {
    width: 100%;
    height: 100%;
    pointer-events: none;
}
</style>
